import { render, staticRenderFns } from "./systemInfo.vue?vue&type=template&id=39351b80&"
import script from "./systemInfo.vue?vue&type=script&lang=ts&"
export * from "./systemInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports